import Spline from '@splinetool/react-spline';
import { Application } from '@splinetool/runtime';
import React from 'react'





export const Model = () => {
  return (
    <>
  

      <Spline scene="https://prod.spline.design/J5jw3SqeASKTmPwv/scene.splinecode"/>
    </>
   
  )
}

